export default class SetupPortalController {
  constructor($scope, $uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
  }

  dismiss(finished, signedUp) {
    const check = {
      finished: finished,
      signedUp: signedUp,
    };
    this.$uibModalInstance.close(check);
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/modals/setup-portal.js